import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import styled from "styled-components";
import { useLocation, useParams } from "react-router-dom";
import CampaignDetail from "./CampaignDetail";
import MessageCampaignDetail from "./MessageCampaignDetail";
import { getCampaignById } from "../../services/campaign.service";
import { isMessagingCampaignChannel } from "./type";

type PageKind = "boot" | "call" | "message";

const CampaignDetailPage: React.FC = () => {
  const { id } = useParams();
  const location = useLocation();
  const hintedChannel = (location.state as { channel?: string } | null)?.channel;
  const [kind, setKind] = useState<PageKind>(() => {
    if (isMessagingCampaignChannel(hintedChannel)) return "message";
    if (hintedChannel) return "call";
    return "boot";
  });
  const [initialCampaign, setInitialCampaign] = useState<any>(null);

  useEffect(() => {
    let cancelled = false;
    const stateChannel = (location.state as { channel?: string } | null)
      ?.channel;

    setInitialCampaign(null);

    if (isMessagingCampaignChannel(stateChannel)) {
      setKind("message");
      return undefined;
    }
    if (stateChannel && !isMessagingCampaignChannel(stateChannel)) {
      setKind("call");
      return undefined;
    }

    setKind("boot");

    (async () => {
      try {
        const res = await getCampaignById(id || "");
        if (cancelled) return;
        const data = res.data?.data;
        setInitialCampaign(data || null);
        setKind(isMessagingCampaignChannel(data?.channel) ? "message" : "call");
      } catch {
        if (!cancelled) setKind("call");
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [id, hintedChannel]);

  if (kind === "boot") {
    return (
      <LoadingOverlay>
        <Spin size="default" />
      </LoadingOverlay>
    );
  }

  if (kind === "message") {
    return (
      <MessageCampaignDetail key={id} initialCampaign={initialCampaign} />
    );
  }

  return <CampaignDetail key={id} />;
};

const LoadingOverlay = styled.div`
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 240px;
  width: 100%;
`;

export default CampaignDetailPage;
